import { upperFirstLetter } from './caseing';
import { getSeriesRelativeUrl, sportSeriesRedirects } from './series';

export enum MarketForm {
    BINARY = 'binary',
    CATEGORICAL = 'categorical',
    NUMERICAL = 'numerical',
    FINANCIAL_UNDERLYING = 'financial-underlying',
}

export const getEventRelativeUrl = (
    seriesTicker: string,
    seriesTitle?: string,
    eventTicker?: string,
    marketTicker?: string,
): string => {
    const baseUrl = getSeriesRelativeUrl(seriesTicker, seriesTitle);
    const queryParams = marketTicker ? `?marketTicker=${marketTicker}` : '';

    // Use slash-based URL structure instead of hash-based
    if (eventTicker) {
        const mappedSeriesTicker = sportSeriesRedirects[seriesTicker] ?? seriesTicker;
        const mappedEventTicker = eventTicker.replace(seriesTicker, mappedSeriesTicker);

        return `${baseUrl}/${mappedEventTicker.toLowerCase()}${queryParams}`;
    }

    return `${baseUrl}${queryParams}`;
};

/**
 * Derive the event ticker from a Kalshi market ticker by dropping the
 * trailing `-MARKET[-…]` segment. Returns `undefined` for tickers without a
 * hyphen (rare single-market events whose market ticker is the event ticker).
 *
 * Example: `KXPGATOUR-CAC26-CAME` → `KXPGATOUR-CAC26`.
 */
export const deriveEventTickerFromMarketTicker = (marketTicker: string): string | undefined => {
    const i = marketTicker.lastIndexOf('-');
    return i > 0 ? marketTicker.slice(0, i) : undefined;
};

export const getMinimalSubtitle = (subtitle: string) => {
    let minimalSubtitle = subtitle;

    // Some prepositions can be inferred
    if (minimalSubtitle.slice(0, 3) === 'In ' || minimalSubtitle.slice(0, 3) === 'On ') {
        minimalSubtitle = upperFirstLetter(subtitle.slice(3));
    }

    return minimalSubtitle;
};
